import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";
import loginRoutes from "./router/LoginRoutes";
import newThemeLoginRoutes from "./router/newthemeLoginRoutes";
import indexRoutes from "./router/indexroutes";
import { useIdleTimer } from "react-idle-timer";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import OfflineDb from "./db";
import GlobalSpinnerContextProvider from "./context/GlobalSpinnerContext";
import GlobalSpinner from "./component/GlobalSpinner/GlobalSpinner";
import { setLoginUser } from "./redux/actions/action";
import { Configuration } from "./assets/data/config";
import { useLocaleConfiguration } from "./hooks/useLocaleConfiguration";
import DynamicCSS from "./hooks/DynamicCSS";
import { getHtmlConfig } from './config/validationutils'; 
const loading = <div className="loading"></div>;

const App = ({ setLoginUser, storeIsLogin }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.body.classList.remove(document.body.classList[0]);
    Configuration.theme.name == "Template1"
      ? document.body.classList.add("theme_blue", "theme_novo")
      : document.body.classList.add("theme_red", "theme_novo");
    OfflineDb.getDataFromPouchDB("loginDetails").then((doc) => {
      if (doc.status == 404 && loggedIn) {
        setLoggedIn(false);
      }
    });
  }, [storeIsLogin]);
  const handleOnIdle = (event) => {
    if (loggedIn && navigator.onLine) {
      OfflineDb.getAllEntities().then((res) => {
        if (res == undefined || res.total_rows == 0) {
          localStorage.clear();
          OfflineDb.deleteDatabse()
            .then((res) => {
              setLoginUser(false);
            })
            .catch((err) => {
              setLoginUser(false);
            });
        } else {
          swal({
            title: t("Offline data"),
            text: t("Offline records found, please sync data before logout"),
            icon: "warning",
            buttons: "Close",
          });
        }
      });
    }
  };
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    // onActive: handleOnActive,
    // onAction: handleOnAction,
    // debounce: 500
  });
  OfflineDb.setPouchDBDatabase();

  const updateLoggedInStatus = () => {
    setLoggedIn(true);
    setLoginUser(true);
  };

  const aIndexRoutes = indexRoutes.map((prop, key) => {
    // if (prop.redirect) {
    //   return <Redirect from={prop.path} to={prop.to} key={key} />;
    // }
    return <Route to={prop.path} component={prop.component} key={key} />;
  });
  const aLoginRoutes = loginRoutes.map((prop, key) => {
    if (prop.redirect) {
      return <Redirect from={prop.path} to={prop.to} key={key} />;
    }
    return (
      <Route
        path={prop.path}
        key={key}
        render={(e) => <prop.component onSuccess={updateLoggedInStatus} />}
      />
    );
  });
  const aNewThemeLoginRoutes = newThemeLoginRoutes.map((prop, key) => {
    if (prop.redirect) {
      return <Redirect from={prop.path} to={prop.to} key={key} />;
    }
    return (
      <Route
        path={prop.path}
        key={key}
        render={(e) => <prop.component onSuccess={updateLoggedInStatus} />}
      />
    );
  });

  const { config, loading, error } = useLocaleConfiguration('App');
  useEffect(() => {
    if (loading) {
       
        if (!document.querySelector('.swal-modal')) {
            swal({
                title: "Loading Configuration...",
                text: "Please wait while the configuration is being loaded.",
                icon: "info",
                buttons: false, 
                dangerMode: true,
            });
        }
    } else {
       
       if (document.querySelector('.swal-modal')) {
        swal.close();
    }
    }

    if (error) {
        swal("Error", `Failed to load configuration: ${error.message}`, "error");
    }

    if(config)
    {
      const htmlConfig = getHtmlConfig();
  
      // Set the title
      document.title = htmlConfig.title;
    
      // Set the meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
          metaDescription.setAttribute('content', htmlConfig.metacontent);
      } else {
          metaDescription = document.createElement('meta');
          metaDescription.name = 'description';
          metaDescription.content = htmlConfig.metacontent;
          document.head.appendChild(metaDescription);
      }
    }

}, [loading, error, config]); // React on changes in loading and error state



useEffect(() => {
  console.log("config ",config)
  if(config){
  //  setCssContent(config)
  }
},[config])

if (!config) {
    // If no config and not loading, show error or empty state
    return loading ? null : <div>No configuration loaded or failed to load</div>;
}



  return (
    <GlobalSpinnerContextProvider>
      <GlobalSpinner />
      <BrowserRouter basename={window.cordova ? "/" : "/cdicv2"}>
        <React.Suspense fallback={<div>Loading</div>}>
          <Switch>
            {loggedIn
              ? aIndexRoutes
              : Configuration.theme.name == "Template1"
              ? aLoginRoutes
              : aNewThemeLoginRoutes}
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    </GlobalSpinnerContextProvider>
  );
};

function mapStateToProps(state) {
  const { storeState } = state;
  return { storeIsLogin: storeState.isLoggedIn };
}

export default connect(mapStateToProps, { setLoginUser })(App);

//export default App;
